import { FC } from 'react';
import { useIntl } from 'react-intl';

import { TeamsPageNameHash } from '../../types';
import messages from './messages';
import { StyledSubText, StyledText, TextWrapper } from './styles';

interface HeroTextProps {
	activePage: TeamsPageNameHash;
}
interface TextContainerProps {
	heading: string;
	subHeading?: string;
	isCoveredLivesPage?: boolean;
}

const TextContainer: FC<TextContainerProps> = ({ heading, subHeading, isCoveredLivesPage = false }) => (
	<TextWrapper $isCoveredLivesPage={isCoveredLivesPage}>
		<StyledText $isCoveredLivesPage={isCoveredLivesPage}>{heading}</StyledText>
		{subHeading && (
			<StyledSubText $isCoveredLivesPage={isCoveredLivesPage} noMargin={isCoveredLivesPage}>
				{subHeading}
			</StyledSubText>
		)}
	</TextWrapper>
);

const HeroText: FC<HeroTextProps> = ({ activePage }) => {
	const { formatMessage } = useIntl();

	if (activePage === '#info') {
		return <TextContainer heading={formatMessage(messages.yourInfoHeading)} />;
	}
	if (activePage === '#company') {
		return <TextContainer heading={formatMessage(messages.companyInfoHeading)} />;
	}
	if (activePage === '#payment') {
		return <TextContainer heading={formatMessage(messages.paymentHeading)} />;
	}

	return (
		<TextContainer
			isCoveredLivesPage
			heading={formatMessage(messages.coveredLivesHeading)}
			subHeading={formatMessage(messages.coveredLivesSubHeading)}
		/>
	);
};

export default HeroText;
